import { render, staticRenderFns } from "./UserListWidget.vue?vue&type=template&id=6e48a375&scoped=true&"
import script from "./UserListWidget.vue?vue&type=script&lang=js&"
export * from "./UserListWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserListWidget.vue?vue&type=style&index=0&id=6e48a375&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e48a375",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VDataTable,VIcon,VLayout})
